export default __webpack_public_path__ + "static/media/favorite.fa7dd4de.svg";